import { all } from 'redux-saga/effects';

import packageSaga from './package-saga';
import assessmentSaga from './assessment-saga';

export default function* rootSaga() {
  yield all([packageSaga(), assessmentSaga()]);
}
